import { render, staticRenderFns } from "./roleScreen.vue?vue&type=template&id=b6dfae1c&scoped=true"
import script from "./roleScreen.vue?vue&type=script&lang=js"
export * from "./roleScreen.vue?vue&type=script&lang=js"
import style0 from "./roleScreen.vue?vue&type=style&index=0&id=b6dfae1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dfae1c",
  null
  
)

export default component.exports